const DEFAULT_PAGE_SIZE = 20

export default DEFAULT_PAGE_SIZE
